import React, { useState, useRef, useEffect } from "react";
import SimpleBar from "simplebar-react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import ReportCommentServices from "../../../../services/COOPServices/ReportCommentService/ReportCommentService";

const CommentDetailReport = ({ comments, reportId, fetchComments }) => {
  const [newComment, setNewComment] = useState("");
  const latestCommentRef = useRef(null);

  console.log(comments.commenter);
  const handlePostComment = async () => {
    if (newComment.trim()) {
      // const newCommentObj = {
      //   // Replace the following with appropriate data, like user info and comment details
      //   id: reportId,
      //   comment: newComment,
      // };

      try {
        // Assuming the API requires an object with certain fields, adjust as necessary
        await ReportCommentServices.create({
          reportId: reportId,
          comment: newComment,
        });

        setNewComment("");
        fetchComments();
      } catch (error) {
        console.error("Error posting comment:", error);
      }
    }
  };

  useEffect(() => {
    if (latestCommentRef.current) {
      latestCommentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [comments]);

  const user = JSON.parse(localStorage.getItem("user"));
  const userImage = user?.user?.image;
  const userImageExtension = user?.user?.imageExtension;
  const imageSrc = userImageExtension
    ? `data:image/${userImageExtension.replace(".", "")};base64,${userImage}`
    : "No Image";

  return (
    <Card>
      <CardHeader className="align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">Comments</h4>
      </CardHeader>
      <CardBody>
        <SimpleBar style={{ height: "350px" }} className="px-3 mx-n3">
          {comments.length === 0 ? (
            <div className="text-center text-muted py-5 mt-5">No comments</div>
          ) : (
            comments.map((comment, index) => (
              <div
                key={comment.id}
                ref={index === comments.length - 1 ? latestCommentRef : null}
              >
                {comment.commenter === "Central" ? (
                  <div className="d-flex mb-4 justify-content-start ">
                    <div>
                      <div className="d-flex justify-content-start gap-2">
                        <img
                          src={"/centraladmin.png"}
                          alt="Central admin logo"
                          className="avatar-xs rounded-circle"
                        />
                        <div
                          className="fs-14 text-start bg-secondary-subtle p-2 rounded"
                          style={{ minWidth: "28vw", maxWidth: "28vw" }}
                        >
                          <div className="d-flex justify-content-between">
                            <span> {comment.userName} </span>
                            <small className="text-muted text-end">
                              {comment.commentedDate}
                            </small>
                          </div>
                          <p className="text-muted mt-2">{comment.comment}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex mb-4 justify-content-end ">
                    <div>
                      <div className="d-flex justify-content-end gap-2">
                        <div
                          className="fs-14 text-end bg-success-subtle p-2 rounded"
                          style={{ minWidth: "28vw", maxWidth: "28vw" }}
                        >
                          <div className="d-flex justify-content-between">
                            <small className="text-muted text-start">
                              {comment.commentedDate}
                            </small>
                            <span> {comment.userName} </span>
                          </div>
                          <p className="text-muted text-start">
                            {comment.comment}
                          </p>
                        </div>
                        <img
                          src={imageSrc}
                          alt=""
                          className="avatar-xs rounded-circle"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </SimpleBar>
        <form className="mt-4">
          <Row className="g-3">
            <Col xs={12}>
              <label className="form-label text-body">Leave a Comment</label>
              <textarea
                className="form-control bg-light border-light"
                rows="3"
                placeholder="Enter your comment..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              ></textarea>
            </Col>
            <Col xs={12} className="text-end">
              <button
                type="button"
                className="btn btn-ghost-secondary btn-icon waves-effect me-1"
              >
                <i className="ri-attachment-line fs-16"></i>
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handlePostComment}
              >
                Post Comment
              </button>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  );
};

export default CommentDetailReport;
// import React, { useState } from "react";
// import SimpleBar from "simplebar-react";
// import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
// import ReportCommentServices from "../../../../services/COOPServices/ReportCommentService/ReportCommentService";

// const CommentDetailReport = ({ comments, reportId, fetchComments }) => {
//   const [newComment, setNewComment] = useState("");

//   console.log(comments.commenter);
//   const handlePostComment = async () => {
//     if (newComment.trim()) {
//       // const newCommentObj = {
//       //   // Replace the following with appropriate data, like user info and comment details
//       //   id: reportId,
//       //   comment: newComment,
//       // };

//       try {
//         // Assuming the API requires an object with certain fields, adjust as necessary
//         await ReportCommentServices.create({
//           reportId: reportId,
//           comment: newComment,
//         });

//         setNewComment("");
//         fetchComments();
//       } catch (error) {
//         console.error("Error posting comment:", error);
//       }
//     }
//   };

//   const user = JSON.parse(localStorage.getItem("user"));
//   const userImage = user?.user?.image;
//   const userImageExtension = user?.user?.imageExtension;
//   const imageSrc = userImageExtension
//     ? `data:image/${userImageExtension.replace(".", "")};base64,${userImage}`
//     : "No Image";

//   return (
//     <Card>
//       <CardHeader className="align-items-center d-flex">
//         <h4 className="card-title mb-0 flex-grow-1">Comments</h4>
//       </CardHeader>
//       <CardBody>
//         <SimpleBar style={{ height: "350px" }} className="px-3 mx-n3">
//           {comments.length === 0 ? (
//             <div className="text-center text-muted py-5 mt-5">No comments</div>
//           ) : (
//             comments.map((comment) => (
//               <div key={comment.id}>
//                 {comment.commenter === "Central" ? (
//                   <div className="d-flex mb-4 justify-content-start ">
//                     <div>
//                       <div className="d-flex justify-content-start gap-2">
//                         <img
//                           src={"/centraladmin.png"}
//                           alt="Central admin logo"
//                           className="avatar-xs rounded-circle"
//                         />
//                         <div
//                           className="fs-14 text-start bg-secondary-subtle p-2 rounded"
//                           style={{ minWidth: "28vw", maxWidth: "28vw" }}
//                         >
//                           <div className="d-flex justify-content-between">
//                             <span> {comment.userName} </span>
//                             <small className="text-muted text-end">
//                               {comment.commentedDate}
//                             </small>
//                           </div>
//                           <p className="text-muted mt-2">{comment.comment}</p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="d-flex mb-4 justify-content-end ">
//                     <div>
//                       <div className="d-flex justify-content-end gap-2">
//                         <div
//                           className="fs-14 text-end bg-success-subtle p-2 rounded"
//                           style={{ minWidth: "28vw", maxWidth: "28vw" }}
//                         >
//                           <div className="d-flex justify-content-between">
//                             <small className="text-muted text-start">
//                               {comment.commentedDate}
//                             </small>
//                             <span> {comment.userName} </span>
//                           </div>
//                           <p className="text-muted text-start">
//                             {comment.comment}
//                           </p>
//                         </div>
//                         <img
//                           src={imageSrc}
//                           alt=""
//                           className="avatar-xs rounded-circle"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ))
//           )}
//         </SimpleBar>
//         <form className="mt-4">
//           <Row className="g-3">
//             <Col xs={12}>
//               <label className="form-label text-body">Leave a Comment</label>
//               <textarea
//                 className="form-control bg-light border-light"
//                 rows="3"
//                 placeholder="Enter your comment..."
//                 value={newComment}
//                 onChange={(e) => setNewComment(e.target.value)}
//               ></textarea>
//             </Col>
//             <Col xs={12} className="text-end">
//               <button
//                 type="button"
//                 className="btn btn-ghost-secondary btn-icon waves-effect me-1"
//               >
//                 <i className="ri-attachment-line fs-16"></i>
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-success"
//                 onClick={handlePostComment}
//               >
//                 Post Comment
//               </button>
//             </Col>
//           </Row>
//         </form>
//       </CardBody>
//     </Card>
//   );
// };

// export default CommentDetailReport;
